import { getItemDisplayLabelForCount } from 'entities/CatalogItem';
import { isCategoryUncategorized } from 'entities/Category';

import type { CatalogItemCategoryChangeInput } from './types';
import type { Category } from 'entities/Category/model/types/CategorySchema';
import type { TFunction } from 'i18next';

export interface DerivedChangeCatalogItemCategoryState {
    catalogItemIds: string[];
    itemDisplayLabel: string;
    initialFormCategoryId: string;
    useAddCategoryTitle: boolean;
}

export const deriveChangeCatalogItemCategoryState = (
    items: CatalogItemCategoryChangeInput[],
    localCategories: Record<string, Category> | undefined,
    t: TFunction,
): DerivedChangeCatalogItemCategoryState | null => {
    if (items.length === 0) {
        return null;
    }

    const catalogItemIds = items.map((row) => row.id);

    const itemDisplayLabel = getItemDisplayLabelForCount(items, t);

    let initialFormCategoryId = '';
    if (items.length === 1) {
        const title = localCategories?.[items[0].categoryId]?.title;
        initialFormCategoryId = isCategoryUncategorized(title)
            ? ''
            : items[0].categoryId;
    } else {
        const categoryIds = new Set(items.map((r) => r.categoryId));
        if (categoryIds.size === 1) {
            const onlyId = [...categoryIds][0];
            const title = localCategories?.[onlyId]?.title;
            initialFormCategoryId = isCategoryUncategorized(title)
                ? ''
                : onlyId;
        }
    }

    const useAddCategoryTitle = items.every((row) =>
        isCategoryUncategorized(localCategories?.[row.categoryId]?.title),
    );

    return {
        catalogItemIds,
        itemDisplayLabel,
        initialFormCategoryId,
        useAddCategoryTitle,
    };
};
